import styled from "@emotion/styled";
import colors from "styles/colors";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MIN_HEADER_DESKTOP_MENU } from "constants/vp-sizes";
const bannerHeight = "72px";
export const StyledVibeBanner = styled.div`
  min-height: ${bannerHeight};
  display: flex;
  justify-content: center;
  background: ${colors.white};
  background-image: url("/static/img/vibe/vibe_addon_banner_left.svg"), url("/static/img/vibe/vibe_addon_banner_right.svg");
  background-repeat: no-repeat, no-repeat;
  background-position: left center, right center;
  color: #333333;
  margin: 24px 0;
  width: 100%;

  .vibe-banner-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
    padding: 0 24px;
    gap: 24px;
    margin: 0 auto;

    @media (min-width: 1440px) {
      padding: 0 130px 0 24px;
    }

    @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
      padding: 16px 20px;
      flex-direction: column;
      gap: 16px;
      align-items: stretch;
    }
  }

  .vibe-banner-left-content {
    display: flex;
    align-items: center;
    gap: 24px;
    flex: 1;

    @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
      flex-direction: column;
      gap: 12px;
      align-items: stretch;
      width: 100%;
    }
  }

  .vibe-banner-text {
    font-size: 1rem;
    line-height: 24px;
    text-align: left;
    white-space: nowrap;
    color: #333333;
    font-weight: 600;

    @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
      white-space: normal;
      text-align: center;
      font-size: 0.875rem;
    }
  }

  .vibe-banner-dropdown {
    min-width: 200px;
    position: relative;

    @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
      min-width: unset;
      width: 100%;
    }

    .published-apps-select {
      .select__control {
        background: ${colors.white};
        border: 1px solid #d5d5d5;
        border-radius: 4px;
        min-height: 40px;
        cursor: pointer;
        box-shadow: none;

        &:hover {
          border-color: #b3b3b3;
        }
      }

      .select__value-container {
        padding: 0 12px;
      }

      .select__single-value {
        color: #333333;
        font-size: 0.875rem;
      }

      .select__indicator-separator {
        display: none;
      }

      .select__dropdown-indicator {
        color: #676879;
        padding: 0 8px;
      }

      .select__menu {
        z-index: 9999;
      }

      .select__menu-portal {
        z-index: 9999;
      }

      .select__option {
        color: #333333;
        font-size: 0.875rem;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
        }

        &.select__option--is-focused {
          background-color: #ebf5ff;
          color: #333333;
        }

        &.select__option--is-selected {
          background-color: #dff0ff;
          color: #007F9B;
        }
      }
    }
  }

  .vibe-banner-right-content {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;

    @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
      justify-content: center;
      width: 100%;
    }

    .vibe-price {
      display: flex;
      align-items: baseline;
      color: #333333;
      font-size: 1rem;
      white-space: nowrap;

      @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
        font-size: 0.875rem;
      }

      .price-amount {
        font-weight: 700;
        font-size: 1.125rem;

        @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
          font-size: 1rem;
        }
      }

      .price-period {
        font-weight: 400;
      }
    }
  }

  @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
    background-image: none;
    background: linear-gradient(90deg, rgba(219, 149, 245, 0.25) 0%, rgba(249, 136, 190, 0.25) 50%, rgba(255, 179, 103, 0.25) 100%), ${colors.white};
    margin: 16px 0;
  }

  @media (max-width: 600px) {
    .vibe-banner-content {
      padding: 12px 16px;
    }

    .vibe-banner-text {
      font-size: 0.8125rem;
    }

    .vibe-price {
      font-size: 0.8125rem;

      .price-amount {
        font-size: 0.9375rem;
      }
    }
  }
`;
